<template>
  <perfect-scrollbar id="sidebar" v-if="signedIn">
    <router-link to="/" class="logoCnt">
      <div class="logo"></div>
      <!-- CMS<span>River</span> -->
    </router-link>

    <div class="user">
      <div class="userPic"></div>
      <p>Welcome</p>
      <h4>{{$session.get('name')}}</h4>
    </div>

    <div :class="{menuCnt: true, showHidden: showHidden}" >
      <h4>Homepage</h4>
      <div :class="{menuItem: true, active: title === 'Homepage - Banner'}">
        <router-link to="/homepage/banner">
          <img src="../assets/slider.png"> Banner</router-link>
        <div class="config" v-on:click="changeSliderStyle()"></div>
      </div>
    </div>

    <div :class="{menuCnt: true, showHidden: showHidden}" >
      <h4>Content</h4>
      <div class="showHidden" v-on:click="showHidden = true" v-if="!showHidden">
        <div class="eye-icon"></div>Show hidden page</div>
      <div class="showHidden" v-on:click="showHidden = false" v-else>
        <div class="eye-icon eye-close"></div>Hide hidden pages</div>
      <div v-for="(item, index) in categories" :key="index"
        :class="{menuItem: true, active: title === `Content - ${item.name}`
        || title === `Page Editor - ${item.name}`,
        isHidden: item.visibility === 'hidden'}">
        <router-link :to="`/article/${item.slug}`">
          <img src="../assets/invisible.png" v-if="item.visibility === 'hidden'">
          <img src="../assets/listing-black.png" v-else>
          {{item.name}}
        </router-link>
        <div class="config" v-on:click="editCategory(index, item)"></div>
      </div>
      <button class="addArticle" v-on:click="addCategory">
        <img src="../assets/listing-add-black.png">
        Add New Page
      </button>
    </div>

    <div class="menuCnt">
      <h4>Bodykey</h4>
      <router-link to="/bodykey/landing-page"
        :class="{menuItem: true, active: title === 'Bodykey - Landing Page'}">
        <img src="../assets/landing-page.png"> Landing Page</router-link>
      <div v-for="(item, index) in bodykeyCats" :key="index"
        :class="{menuItem: true, active: title === `Bodykey - ${item.name}`,
        isHidden: item.visibility === 'hidden'}">
        <router-link :to="`/article/${item.slug}`">
          <img src="../assets/invisible.png" v-if="item.visibility === 'hidden'">
          <img src="../assets/listing-black.png" v-else>
          {{item.name}}
        </router-link>
        <div class="config" v-on:click="editCategory(index, item)"></div>
      </div>
      <div :class="{menuItem: true, active: title === 'Bodykey - Instagram Video Competition',
        isHidden: vidMenu.visibility === 'hidden'}" v-if="vidMenu">
        <router-link :to="`/article/${vidMenu.slug}`">
          <img src="../assets/invisible.png" v-if="vidMenu.visibility === 'hidden'">
          <img src="../assets/listing-black.png" v-else>
          {{vidMenu.name}}
        </router-link>
        <div class="config" v-on:click="editCategory(0, vidMenu)"></div>
      </div>
    </div>

    <div class="menuCnt">
      <h4>Media</h4>
      <router-link to="/media/all"
        :class="{menuItem: true, active: title === 'All Media'}">
        <img src="../assets/image-black.png"> All Media</router-link>
      <a href="/media/all" v-on:click.prevent="upload"
        :class="{menuItem: true, active: title === 'Upload'}">
        <img src="../assets/upload-black.png"> Upload Media</a>
    </div>

    <div class="menuCnt">
      <h4>User Content</h4>
      <router-link to="/user-content/tes-lelah"
        :class="{menuItem: true, active: title == 'Tes Lelah'}">
        <img src="../assets/user-list.png"> Tes Lelah</router-link>
      <router-link to="/user-content/kompetisi-resep-sehat"
        :class="{menuItem: true, active: title == 'Kompetisi Resep Sehat'}">
        <img src="../assets/user-list.png"> Kompetisi Resep Sehat</router-link>
      <router-link to="/user-content/nutrilite-recommender"
        :class="{menuItem: true, active: title == 'Nutrilite Recommender'}">
        <img src="../assets/user-list.png"> Nutrilite Recommender</router-link>
    </div>

    <div class="menuCnt">
      <h4>Settings</h4>
      <router-link to="/settings"
        :class="{menuItem: true, active: title == 'Web Config'}">
        <img src="../assets/gear.png"> Web Config</router-link>
      <router-link to="/amway-store"
        :class="{menuItem: true, active: title === 'Amway Store'}">
        <img src="../assets/organization-black.png"> Amway Store</router-link>
      <router-link to="/users/admin"
        :class="{menuItem: true, active: title === 'Admin'}">
        <img src="../assets/user-setting-black.png"> Admin</router-link>
      <router-link to="/article/static"
        :class="{menuItem: true, active: title === 'Content - Static'}">
        <img src="../assets/listing-black.png"> Static Pages</router-link>
    </div>

    <div class="about">
      <p><b>Contact:</b>
        <a href="#">hi@cmsriver.com</a>
      <ul>
        <li><a href="#">Term of Use</a></li>
        <li><a href="#">Privacy Policy</a></li>
        <li><a href="#">Copyright</a></li>
      </ul>
      <div class="copyright">&copy; Copyright 2020 CMSRiver</div>
      <div class="poweredBy">
        <h4>Powered by</h4>
        <a href="https://cmsriver.com" target="_blank">
          <div class="logo"></div>
          CMS<span>River</span>
        </a>
      </div>
    </div>
    <AddArticleCategory ref="showInputer"/>
    <MediaUploader ref="mediaUploader"/>
    <SliderStyle ref="sliderStyle"/>
  </perfect-scrollbar>
</template>

<script>
import { mapState } from 'vuex';
import MediaUploader from '@/components/MediaUploader.vue';
import AddArticleCategory from '@/components/AddArticleCategory.vue';
import SliderStyle from '@/components/SliderStyle.vue';

export default {
  name: 'sidebar',
  components: {
    AddArticleCategory,
    MediaUploader,
    SliderStyle,
  },
  data() {
    return {
      showHidden: false,
      categories: [],
      bodykeyCats: [],
      vidMenu: null,
    };
  },
  methods: {
    getCategories() {
      this.$http.get(this.$config.uri('article/pages?bodykey=0')).then((response) => {
        this.categories = (response.data.status === 200) ? response.data.data : [];
        this.showInputer = false;
      });
      this.$http.get(this.$config.uri('article/pages?bodykey=1')).then((response) => {
        this.bodykeyCats = (response.data.status === 200) ? response.data.data : [];
      });
      this.$http.get(this.$config.uri('article/page/instagram-video-competition')).then((r) => {
        this.vidMenu = (r.data.status === 200) ? r.data.data : null;
      });
    },
    changeSliderStyle() {
      this.$refs.sliderStyle.open();
    },
    editCategory(i, item) {
      this.$router.push(`/page/editor/${item.slug}`);
    },
    addCategory() {
      this.$refs.showInputer.open({
        title: 'New Page',
        placeholder: 'Page Name',
        description: true,
        action: 'Save Page',
        required: true,
        model: null,
      }, (b, d) => {
        if (!b) return;
        this.categories.push(d);
        this.$router.push(`/article/${d.slug}`);
      });
    },
    saveCategory() {
      this.getCategories();
    },
    upload() {
      document.getElementsByTagName('BODY')[0].classList.add('selectingMedia');
      this.$refs.mediaUploader.open(null, (b) => {
        setTimeout(() => {
          document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
        }, 200);
        if (this.$route.path !== '/media/all') {
          this.$router.push('/media/all');
        } else {
          window.location.reload();
        }
      });
    },
  },
  computed: {
    ...mapState([
      'title', 'signedIn',
    ]),
  },
  mounted() {
    this.getCategories();
  },
};
</script>

<style lang="scss">
  body.selectingMedia{
    overflow: hidden;
    .formAction{
      display: none;
    }
    .contentHeader{
      display: none;
    }
  }
</style>

<style scoped lang="scss">
  #sidebar{
    // position: relative;
    width: 300px;
    background-color: #0747a6;
    background-color: #fff;
    padding: 10px 40px 20px 40px;
    color: #fff;
    color: #444;
    box-sizing: border-box;
    height: 100vh;
    overflow: auto;
    // z-index: 99;
    border-right: #eee 1px solid;
  }

  .about{
    font-size: 13px;
    margin-top: 40px;
    a{
      display: block;
      padding: 1px 0;
      padding-right: 10px;
      color: #fff;
      color: #444;
      opacity: .7;
    }
    a:hover{
      opacity: 1;
    }
    p{
      margin-bottom: 10px;
      b{
        opacity: .6;
      }
    }
    ul{
      margin: 0;
      padding: 0;
      margin-bottom: 10px;
      li{
        list-style20px: none;
        display: inline-block;
      }
    }
    .copyright{
      opacity: .7;
    }
  }

  .logoCnt{
    display: block;
    padding-top: 12px;
    position: relative;
    padding-left: 43px;
    color: #fff;
    font-size: 28px;
    font-weight: lighter;
    height: 50px;
    span{
      font-weight: 600;
    }
    .logo{
      position: absolute;
      top: 12px;
      left: -1px;
      width: 100%;
      height: 56px;
      background-position: left center;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url(../assets/nutrilite-logo.png);
      // border-radius: 50%;
    }
  }
  .user{
    padding-top: 30px;
    position: relative;
    padding-left: 74px;
    .userPic{
      position: absolute;
      top: 30px;
      left: 0;
      background-color: #fff;
      background-color: #eee;
      background-image: url(../assets/user.png);
      background-size: cover;
      border-radius: 50%;
      width: 56px;
      height: 56px;
    }
    p{
      margin: 0;
      opacity: .7;
      padding-top: 5px;
    }
    h4{
      margin: 0;
      font-size: 20px;
      white-space: nowrap;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .newListing{
    margin-top: 40px;
    border: #1270ff 2px solid;
    background-color: #1270ff;
    border-radius: 50px;
    padding: 8px 10px 10px;
    text-align: center;
    font-size: 19px;
    text-transform: uppercase;
    font-weight: 600;
    box-shadow: 2px 2px 8px rgba(0,0,0,.2);
    cursor: pointer;
    display: block;
    color: #fff;
    color: #444;
    img{
      height: 20px;
      margin-bottom: -3px;
      margin-right: 4px;
    }
  }
  .newListing:hover{
    background-color: #015eec;
    border-color: #015eec;
  }

  .menuCnt{
    margin-top: 26px;
    .showHidden{
      color: #767676;
      padding: 5px 12px;
      padding-left: 44px;
      position: relative;
      border-radius: 50px;
      margin: 0 -12px 4px;
      font-size: 14px;
      cursor: pointer;
      transition: all .3s ease;
      .eye-icon{
        width: 18px; height: 18px;
        position: absolute;
        background-image: url(../assets/eye.png);
        background-size: contain;
        top: 5px; left: 12px;
        opacity: .6;
        &.eye-close{
          background-image: url(../assets/eye-closed.png);
        }
      }
      &:hover{
        background-color: #eee;
        color: #444;
      }
    }
    .addArticle{
      color: #fff;
      color: #444;
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px 12px 7px;
      margin: 9px -12px 0;
      display: block;
      width: calc(100% + 24px);
      box-sizing: border-box;
      border-radius: 50px;
      text-align: left;
      outline: 0;
      opacity: .5;
      img{
        height: 20px;
        margin-right: 9px;
        margin-bottom: -5px;
        opacity: .6;
      }
      &:hover{
        background-color: rgba(0,0,0,.1);
        opacity: .9;
        img{
          opacity: .7;
        }
      }
    }
    h4{
      margin: 0;
      opacity: .5;
      text-transform: uppercase;
      padding-bottom: 8px;
    }
    .menuItem{
      display: block;
      margin: 0 -12px;
      padding: 8px 12px;
      border-radius: 7px;
      cursor: pointer;
      font-size: 17px;
      color: #fff;
      color: #444;
      margin-bottom: 4px;
      position: relative;
      &.disabled{
        opacity: .4 !important;
        cursor: default;
        background: none !important;
        img{
          opacity: .6 !important;
        }
      }
      a{
        color: #fff;
        color: #444;
        display: block;
        padding: 8px 12px;
        margin: -8px -12px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      &.isHidden{
        display: none;
        img{
          opacity: .4;
          margin-bottom: -4px;
        }
        a{
          color: #767676;
        }
        &.active{
          a{
            color: #444;
          }
        }
      }
      .config{
        position: absolute;
        top: 4px; right: 4px;
        border-radius: 50%;
        width: 30px; height: 30px;
        background-image: url(../assets/settings-black.png);
        background-size: 18px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .4;
        display: none;
        &:hover{
          opacity: .8;
        }
      }
      &:hover{
        .config{
          display: block;
        }
      }
      img{
        height: 20px;
        margin-right: 9px;
        margin-bottom: -3px;
        opacity: .6;
      }
      &.active{
        background-color: #0e5dd2 !important;
        background-color: #c4e894 !important;
        img{
          opacity: .7;
        }
      }
      &:hover{
        background-color: #033e96;
        background-color: #eee;
        // box-shadow: 2px 2px 8px rgba(0,0,0,.2);
        img{
          opacity: .7;
        }
      }
    }
    &.showHidden{
      .isHidden{
        display: block;
      }
    }
  }

  .poweredBy{
    font-size: 15px;
    font-weight: lighter;
    padding-top: 10px;
    a{
      padding: 0;
      opacity: 1;
    }
    h4{
      margin: 0;
      opacity: .7;
      font-size: 12px;
      margin-bottom: 4px;
    }
    span{
      font-weight: normal;
    }
    .logo{
      width: 16px;
      height: 16px;
      background-image: url(../assets/cmsriver-logo.png);
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      float: left;
      margin-right: 6px;
      margin-bottom: -5px;
      margin-top: 1px;
    }
  }
</style>
